class PagingColumn {
  name;
  sortable;
  resizable;
  align;
  width;
  visible = true;
  hideWhenCompacted = false;

  constructor(
    name,
    sortable,
    resizable,
    align,
    width,
    visible = true,
    hideWhenCompacted = false
  ) {
    this.name = name;
    this.sortable = sortable;
    this.resizable = resizable;
    this.align = align;
    this.width = width;
    this.visible = visible;
    this.hideWhenCompacted = hideWhenCompacted;
  }
}
export default PagingColumn;
